var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"question-style"},[_vm._v(" "+_vm._s(_vm.question && _vm.question.no)+". "),_c('span',{staticClass:"ml-2",domProps:{"innerHTML":_vm._s(_vm.overrideQuestion(_vm.question && _vm.question.content))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }